import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import TeaserSearch from "components/security/teaser/TeaserSearch";
import { Alert } from "components/bootstrap";
import viewJson from "./sample-dashboards/overview_view.json";
import searchJson from "./sample-dashboards/overview_search.json";
import resultJson from "./sample-dashboards/overview_results.json";
const StyledAlert = styled(Alert)`
  margin-top: 0;
`;
const ClusterManagementTeaserSearch = () => {
  const { t } = useTranslation("collectors", { keyPrefix: "datanode" });
  const hotspots = [
    {
      positionX: "50%",
      positionY: "120px",
      description: t("cluster_management.teaser_hotspot")
    }
  ];
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledAlert, { bsStyle: "warning" }, t("cluster_management.teaser_license_warning")), /* @__PURE__ */ React.createElement(
    TeaserSearch,
    {
      viewJson,
      searchJson,
      searchJobResult: resultJson,
      hotspots
    }
  ));
};
export default ClusterManagementTeaserSearch;
